export enum RoutePath {
  FourQuestionVerification = '/',
  ConfirmMobileNumber = '/confirmation',
  OneTimePasscode = '/one-time-passcode',
  OneTimePasscodeServiceDown = '/service-down',
  Locked = '/locked',
  Error = '/error',
  LoggedOut = '/logged-out',
  ServerError = '/server-error',
  Timeout = '/timeout',
  CaseTracking = '/summary'
}

export interface PaginatedResponse<Entity> {
  data: Entity[];
  total: number;
  offset: number;
}
